import ThemeColors from "../colors";

const typography = {
    fontFamily: "Gilroy",
    h1: {
        fontSize: "40px !important",
        fontWeight: 700 + " !important",
        '@media (max-width:900px)': {
            fontSize: "30px !important",
        },
    },
    h2: {
        fontSize: "36px !important",
        // fontWeight: 900 + " !important",
        color: ThemeColors.redColor,
        '@media (max-width:900px)': {
            fontSize: "30px !important",
        },
    },
    h3: {
        fontSize: "24px !important",
        fontWeight: 800 + " !important",
        '@media (max-width:900px)': {
            fontSize: "22px !important",
        },
    },
    h4: {
        fontSize: "22px !important",
        fontWeight: 700 + " !important",
        '@media (max-width:900px)': {
            fontSize: "20px !important",
        },
    },
    h5: {
        fontSize: "20px !important",
        fontWeight: 600 + " !important",
        '@media (max-width:900px)': {
            fontSize: "18px !important",
        },
    },
    h6: {
        fontSize: "18px !important",
        fontWeight: 500 + " !important",
        '@media (max-width:900px)': {
            fontSize: "16px !important",
        },
    },
    body1: {
        fontSize: "16px !important",
        fontWeight: 500 + " !important",
        '@media (max-width:900px)': {
            fontSize: "14px !important",
        },
    },
    body2: {
        fontSize: "14px !important",
        fontWeight: 400 + " !important",
        '@media (max-width:900px)': {
            fontSize: "12px !important",
        },
    },
    caption: {
        fontSize: "12px !important",
        fontWeight: 300 + " !important",
        '@media (max-width:900px)': {
            fontSize: "10px !important",
        },
    },
    subtitle1: {
        fontSize: "10px !important",
        fontWeight: 300 + " !important",
        textDecoration: "underline",
        '@media (max-width:900px)': {
            fontSize: "10px !important",
        },
    },
    subtitle2: {
        fontSize: "8px !important",
        fontWeight: 300 + " !important",
        '@media (max-width:900px)': {
            fontSize: "10px !important",
        },
    },
    button: {
        color: ThemeColors.brandingRed,
        borderRadius: 30,
        textTransform: "none",
        fontSize: 16,
        '@media (max-width:900px)': {
            fontSize: 14,
        },
    },
};

export default typography


// When you make a refactor, use this version
// A great modern scale for web UIs is 1.25 (Major Third) — Each level = previous level × 1.25
// const typography = {
//     fontFamily: "Gilroy, Roboto, Helvetica, Arial, sans-serif",
//
// h1: { fontSize: 56, fontWeight: 700, lineHeight: 1.1 },
// h2: { fontSize: 44, fontWeight: 700, lineHeight: 1.2 },
// h3: { fontSize: 36, fontWeight: 600, lineHeight: 1.3 },
// h4: { fontSize: 28, fontWeight: 600, lineHeight: 1.35 },
// h5: { fontSize: 20, fontWeight: 600, lineHeight: 1.4 },
// h6: { fontSize: 16, fontWeight: 600, lineHeight: 1.45 },
//
// subtitle1: { fontSize: 14, fontWeight: 500, lineHeight: 1.6 },
// subtitle2: { fontSize: 12, fontWeight: 500, lineHeight: 1.6 },
// body1: { fontSize: 14, fontWeight: 400, lineHeight: 1.6 },
// body2: { fontSize: 12, fontWeight: 400, lineHeight: 1.6 }
// };
// export default typography;
